import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
export const useStyles = makeStyles(
  (theme) => ({
    popper: {
      zIndex: 1,
    },
    tooltipRatings: {
      maxWidth: 'none',
      padding: theme.spacing(1),
      backgroundColor: 'unset',
      margin: 0,
    },
    ratingsBannerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      padding: theme.spacing(3, 3, 2, 3),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      color: COLORS.gray.black,
      zIndex: 1000,
      borderRadius: theme.shape.borderRadius,
      width: 361,
      boxShadow: theme.shape.boxShadowLarge,
      marginLeft: -128,
      marginTop: -4,
    },
    footerButton: {
      color: COLORS.primary.default,
      minWidth: 'auto',
      height: 'auto',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0.5, 1),

      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
    },
    ratingsHeader: {
      width: '100%',
    },
    ratingsSubheader: {
      color: COLORS.gray.gray30,
      margin: theme.spacing(1, 0),
    },
    moreRatings: {
      backgroundColor: '#fff5df',
      width: '100%',
      textAlign: 'center',
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadiusSmall,
      marginTop: theme.spacing(1),
    },
    ratingsPair: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      gap: theme.spacing(6),
      margin: theme.spacing(2, 0, 3, 0),
    },

    ratingsLoader: {
      margin: theme.spacing(5, 0, 4, 0),
    },
    clearRatings: {
      cursor: 'pointer',
      marginTop: theme.spacing(2),
      color: COLORS.gray.gray30,
    },
    ratingWrapper: {
      width: '100%',
    },
    ratingScoreWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      width: '100%',
      backgroundColor: COLORS.gray.background,
      borderRadius: theme.shape.borderRadiusSmall,
      padding: theme.spacing(2, 0, 0, 0),
    },
    ratingScore: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    ratingScoreSep: { color: COLORS.gray.gray30, margin: theme.spacing(6, 1.5) },
    ratingScoreName: { textAlign: 'center' },
  }),
  { name: 'PersonalizeButton' }
);
